export default __webpack_public_path__ + "static/media/chevron-down.250b05ec.svg";